<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="text-center mb-5">
            <img src="/img/brand/logo-login.png" height="74" />
          </div>

          <b-card class="p-4">
            <b-form v-loading="loading" @submit.prevent="changePassword()">
              <h1>Create New Password</h1>
              <p class="text-muted">Create a new password for your account below. Be sure to include letters, numbers and symbols to make it secure!</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input v-model="password1" type="password" class="form-control" placeholder="new password" autocomplete="off" />
              </b-input-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input v-model="password2" type="password" class="form-control" placeholder="confirm password" autocomplete="off" />
              </b-input-group>
              <b-alert :show="!!error" fade variant="danger">{{error}}</b-alert>
              <b-row>
                <b-col cols="6">
                  <b-button variant="primary" class="px-4" type="submit">{{isNew ? 'Get Started' : 'Change Password'}}</b-button>
                </b-col>
                <b-col v-if="!isNew" cols="6" class="text-right">
                  <b-button variant="link" class="px-0" :to="prevPage">Already a member</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Forgot",

  data() {
    return {
      password1: "",
      password2: "",

      // State
      loading: false,
      error: ""
    };
  },

  beforeRouteEnter(to, from, next) {
    const { $API } = new Vue();

    // Verify token is good
    $API.v2.Users.VerifyPasswordResetToken(to.query.token)
      .then(valid => {
        if (!valid) {
          next("/login");
          return;
        }

        next();
      })
      .catch(() => {
        next("/login");
      });
  },

  computed: {
    prevPage(){
      if( this.$route.query.next ){
        return `/login?next=${encodeURIComponent(this.$route.query.next)}`
      }

      return '/login'
    },
    nextPage(){
      return this.$route.query.next || "/dashboard"
    },
    isNew(){
      return parseInt(this.$route.query.new) === 1
    }
  },

  methods: {
    changePassword() {
      let { password1, password2 } = this;
      let token = this.$route.query.token;

      // Prevent duplicate submit
      const $focus = document.querySelector(":focus")
      $focus && $focus.blur()

      if( this.loading ){
        return
      }

      this.loading = true;
      this.error = "";

      // @TODO validation
      this.$API.v2.Users.ResetPassword(token, password1, password2)
      .then(() => {
        this.$router.push(this.nextPage)
      })
      .catch(err => {
        this.loading = false;
        this.error = err;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  background: #2f353d;
}
</style>
